import React from "react";
import { Button } from "@shoptet/ui";
import { useTranslation } from "react-i18next";

interface MetaWizardFooterProps {
  backButtonHandler?: () => void;
  nextButtonDisabled?: boolean;
  nextButtonHandler?: () => void;
  showBackButton?: boolean;
  showNextButton?: boolean;
  validationMessage?: string;
}

const MetaWizardFooter: React.FC<MetaWizardFooterProps> = ({
  backButtonHandler,
  nextButtonDisabled = false,
  nextButtonHandler,
  showBackButton = true,
  showNextButton = true,
  validationMessage,
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Meta" });
  return (
    <div style={{ display: "flex", marginTop: "16px", alignItems: "center", justifyContent: "space-between" }}>
      {showBackButton && backButtonHandler && (
        <Button variant="secondary" onClick={backButtonHandler}>
          {t("Back")}
        </Button>
      )}
      {!showBackButton && <div />}
      {showNextButton && nextButtonHandler && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
          <Button disabled={nextButtonDisabled} variant="primary" onClick={nextButtonHandler}>
            {t("Continue")}
          </Button>
          {validationMessage && (
            <span style={{ color: "var(--app-critical)", fontSize: "12px", marginTop: "8px" }}>
              {validationMessage}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default MetaWizardFooter;
